
import React from 'react';
import clsx from 'clsx';
import customStyles from "../../../../../assets/styles/customStyles";
import { NavLink } from "react-router-dom";

export const CategoryView = (props) => {
    const { details, handleParentClick } = props;
    const classes = customStyles();
    return (
        <>
            {
                details?.length > 0 ? details.map((data, i) => (
                    <div key={i} className={clsx(classes.colInline, classes.margin20t)}>
                        <div className={clsx(classes.categoryListLink)}>
                            <NavLink to="#" onClick={() => handleParentClick('category', data)} >
                                <div className={clsx(classes.catalogueTitle)}>{data?.categoryName}</div>
                                <div className={clsx(classes.catalogueDesign)}>
                                    <div className={clsx(classes.catalogueDesign2)}></div>
                                </div>
                            </NavLink>
                        </div>
                    </div>
                )) : <div className={clsx(classes.noResults, classes.colInline)} >
                    <div className={clsx(classes.noResultsText)}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'No results found'}</p></div>
                </div>
            }
        </>
    )
}